import { bucketsStyles } from "@insite/content-library/Widgets/InvoiceHistory/InvoiceHistoryBuckets";
import { mediaQueriesBP } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

bucketsStyles.container = {
    ...bucketsStyles.container,
    css: css`
        ${bucketsStyles.container?.css}
        margin-block: 40px;
        ${mediaQueriesBP.maxMD} {
            margin-block: 24px;
        }
    `,
};

bucketsStyles.item = {
    ...bucketsStyles.item,
    css: css`
        ${bucketsStyles.item?.css}
        padding-bottom: 0 !important;
        span,
        p {
            font-weight: 400;
            font-size: 16px;
        }

        ${mediaQueriesBP.maxMD} {
            & > div {
                padding-inline-end: 10px;
            }
        }
    `,
};
